import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Badge, IconButton, Tooltip } from "@mui/material";

import { useShoppingCart } from "hooks/useShoppingCart";

export const CartMenu = () => {
  const { openShoppingCart, items } = useShoppingCart();

  return (
    <Tooltip title="Carrito">
      <IconButton onClick={openShoppingCart} size="large">
        <Badge badgeContent={items?.length || 0} color="primary">
          <ShoppingCartIcon sx={{ zIndex: 10 }} />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};
